// One-time cleanup for the retired language-preference feature. The site used
// to remember the visitor's language choice (localStorage "vb-lang" and the
// "vb_lang" cookie) and auto-redirect on later visits. That redirect was
// removed; this module only deletes any leftover stored preference so
// returning visitors are not stuck with stale data. It writes nothing.
export const LANG_STORAGE_KEY = "vb-lang";
export const LANG_COOKIE = "vb_lang";

let cleaned = false;

/** Deletes any stored language preference. Safe to call on every page load. */
export function clearLanguagePreference() {
  if (cleaned || typeof window === "undefined") return;
  cleaned = true;
  try {
    window.localStorage.removeItem(LANG_STORAGE_KEY);
  } catch {
    // localStorage can throw in private mode; the cookie cleanup still runs.
  }
  if (typeof document !== "undefined") {
    document.cookie = `${LANG_COOKIE}=; path=/; max-age=0; SameSite=Lax`;
  }
}
